module.exports = {"pathContext":{"name":"ActionsEnum","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DELETE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"INSERT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"UPDATE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-actions-enum.json
// module id = 1201
// module chunks = 280940121040016